import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function SitemarkIcon({customCss}) {
  return (
    <SvgIcon sx={{ height: 42, width: 200, mr: 2, ...customCss }}>
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="1080" height="1080" viewBox="0 0 1080 1080">
        <desc>Aliatis OÜ</desc>
        <defs />
        <rect x="0" y="0" width="100%" height="100%" fill="transparent" />
        <g transform="matrix(1 0 0 1 540 540)" id="afc7332a-ed2d-4b13-8ceb-9953cd9d8e71">
          <rect
            style={{ stroke: 'none', strokeWidth: 1, fill: 'rgb(255,255,255)', opacity: 1, visibility: 'hidden' }}
            vectorEffect="non-scaling-stroke"
            x="-540"
            y="-540"
            rx="0"
            ry="0"
            width="1080"
            height="1080"
          />
        </g>
        <g transform="matrix(1 0 0 1 540 540)" id="c92682e2-faea-45fd-8ea3-972d03106df5" />
        <g transform="matrix(0.91 0 0 0.91 521.19 561.5)">
          <circle
            style={{ stroke: 'none', strokeWidth: 1, fill: 'rgb(72,118,238)', opacity: 1 }}
            vectorEffect="non-scaling-stroke"
            cx="0"
            cy="0"
            r="512"
          />
        </g>
        <g transform="matrix(0.77 0 0 0.91 520.39 506.4)">
          <path
            style={{ stroke: 'none', strokeWidth: 1, fill: 'rgb(255,255,255)', opacity: 1 }}
            vectorEffect="non-scaling-stroke"
            transform="translate(-540, -475)"
            d="M 512 200 L 400 750 L 480 750 L 512 600 L 544 600 L 600 750 L 680 750 L 560 400 L 512 200 Z"
            strokeLinecap="round"
          />
        </g>
        <g transform="matrix(1.19 0 0 1.19 508.65 285.23)" id="76605dd1-50c1-40bb-8356-94d0b6b42740">
          <circle
            style={{ stroke: 'rgb(0,0,0)', strokeWidth: 0, fill: 'rgb(255,255,255)', opacity: 1 }}
            vectorEffect="non-scaling-stroke"
            cx="0"
            cy="0"
            r="35"
          />
        </g>
        <g transform="matrix(1.41 0 0 1.41 452.29 757.91)" id="902bfad6-2c41-4368-92f1-cdb1d68d8ec6">
          <path
            style={{ stroke: 'rgb(0,0,0)', strokeWidth: 0, fill: 'rgb(255,255,255)', opacity: 1 }}
            vectorEffect="non-scaling-stroke"
            transform="translate(-50, -50)"
            d="M 94.75 50 C 94.75 56.213 89.514 61.25 83.054 61.25 L 16.946 61.25 C 10.486 61.25 5.25 56.213 5.25 50 L 5.25 50 C 5.25 43.787 10.486 38.75 16.945999999999998 38.75 L 83.053 38.75 C 89.514 38.75 94.75 43.787 94.75 50 L 94.75 50 z"
            strokeLinecap="round"
          />
        </g>
        <g transform="matrix(1.37 -0.33 0.33 1.37 609.7 748.12)">
          <path
            style={{ stroke: 'rgb(0,0,0)', strokeWidth: 0, fill: 'rgb(255,255,255)', opacity: 1 }}
            vectorEffect="non-scaling-stroke"
            transform="translate(-50, -50)"
            d="M 94.75 50 C 94.75 56.213 89.514 61.25 83.054 61.25 L 16.946 61.25 C 10.486 61.25 5.25 56.213 5.25 50 L 5.25 50 C 5.25 43.787 10.486 38.75 16.945999999999998 38.75 L 83.053 38.75 C 89.514 38.75 94.75 43.787 94.75 50 L 94.75 50 z"
            strokeLinecap="round"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
